import { render, staticRenderFns } from "./MyInterestsApp.vue?vue&type=template&id=5d8c49e5&"
import script from "./MyInterestsApp.vue?vue&type=script&lang=js&"
export * from "./MyInterestsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports